import { PiCheckCircle, PiArrowRightLight } from 'react-icons/pi';
import { Bullet } from '../resourceContentUtils';

interface ArticleBulletsProps {
  bullets: Bullet[];
}

interface SubBulletProps {
  bullet: Bullet;
}

const SubBullets = ({ bullet }: SubBulletProps) => {
  return (
    <ul className="list-none space-y-2 m-0 p-0 mt-2">
      {bullet.sub_bullet?.map((subBullet, index) => {
        const subBulletParts = subBullet.sub_bullet_text.split(':');

        return (
          <li className="flex items-start space-x-3 list-none" key={index}>
            <PiArrowRightLight className="text-primary size-4 mt-1 shrink-0" />
            <div className="prose dark:prose-invert w-full">
              {subBulletParts.length > 1 ? (
                <>
                  <strong>{subBulletParts[0]}:</strong>
                  {subBulletParts.slice(1).join(':')}
                </>
              ) : (
                subBullet.sub_bullet_text
              )}
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export const ArticleBullets = ({ bullets }: ArticleBulletsProps) => {
  return (
    <ul className="space-y-3">
      {bullets.map((bullet, index) => {
        // Split the bullet text at the colon
        const parts = bullet.bullet_text.split(':');

        return (
          <li className="items-start space-x-2 flex list-none" key={index}>
            <PiCheckCircle className="text-primary size-6 shrink-0" />
            <div className="prose dark:prose-invert text-lg">
              {parts.length > 1 ? (
                <>
                  <strong>{parts[0]}:</strong>
                  {parts.slice(1).join(':')}
                </>
              ) : (
                bullet.bullet_text
              )}
              {bullet.sub_bullet && <SubBullets bullet={bullet} />}
            </div>
          </li>
        );
      })}
    </ul>
  );
};
